import { gql, useMutation } from '@apollo/client';

const DELETE_TICKET = gql`
    mutation DeleteTicket($keyId: Uuid = "") {
        v2DeleteTicketsById(keyId: $keyId) {
            affectedRows
        }
    }
`;

const useDeleteTicket = () => {
    const [deleteTicket, { loading, error }] = useMutation(DELETE_TICKET,
        {
            context: {
                headers: {
                    'x-hasura-role': 'learner'
                }
            }
        }
    );
    return { deleteTicket, loading, error };
}

export default useDeleteTicket;